import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const integrationsLightspeedAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.IntegrationsView, Permission.IntegrationsModify],
  warehouseFeatureToggles: FeatureToggle.integrationLightspeed,
}
